module.exports = ".custom-btn {\n  background: #0e9e82;\n  line-height: 1;\n  width: 30%;\n  margin: 0px auto;\n}"